import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { HeartHandshake } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid email or password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-5 bg-secondary">
      <div className="w-full max-w-sm bg-background border border-border p-10">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <HeartHandshake className="h-6 w-6 text-accent" strokeWidth={1.5} />
          <span className="font-heading text-xl font-semibold">PhysioAbhi Admin</span>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="admin-email" className="text-sm font-medium">Email</Label>
            <Input id="admin-email" type="email" data-testid="admin-login-email-input" required className="rounded-none mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="admin-password" className="text-sm font-medium">Password</Label>
            <Input id="admin-password" type="password" data-testid="admin-login-password-input" required className="rounded-none mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button type="submit" disabled={submitting} data-testid="admin-login-submit-button" className="w-full rounded-none bg-accent text-accent-foreground hover:opacity-90">
            {submitting ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
